const client1bForm = {
  pageTitle: "1B-Formular",
  checkingLink: "Link wird geprüft …",
  invalidLinkTitle: "Link ungültig",
  invalidLinkBody:
    "Dieser Link zum 1B-Formular ist nicht gültig. Bitte wenden Sie sich an Ihre Beratungsstelle, wenn Sie das Formular ausfüllen möchten.",
  placeholder: "Platzhalter 1B-Formular",
};

export default client1bForm;
